import React, { useState } from 'react';
import { bool, func, number, shape, string } from 'prop-types';
import classNames from 'classnames';
import { Modal, PrimaryButton } from '../../components';

import css from './WifiSpeedModal.module.css';

const WifiSpeedModal = props => {
  const {
    isOpen,
    onClose,
    onSave,
    onCancel,
    currentSpeeds,
    className,
    rootClassName,
  } = props;

  const [downloadSpeed, setDownloadSpeed] = useState(
    currentSpeeds?.download?.toString() || ''
  );
  const [uploadSpeed, setUploadSpeed] = useState(
    currentSpeeds?.upload?.toString() || ''
  );
  const [errors, setErrors] = useState({ download: null, upload: null });

  const validateSpeed = value => {
    if (!value || value.trim() === '') {
      return null; // Empty is valid (optional)
    }
    const numValue = parseFloat(value);
    if (isNaN(numValue) || numValue <= 0) {
      return 'Please enter a positive number';
    }
    return null;
  };

  const handleDownloadChange = e => {
    const value = e.target.value;
    setDownloadSpeed(value);
    setErrors(prev => ({ ...prev, download: validateSpeed(value) }));
  };

  const handleUploadChange = e => {
    const value = e.target.value;
    setUploadSpeed(value);
    setErrors(prev => ({ ...prev, upload: validateSpeed(value) }));
  };

  const handleSave = () => {
    const downloadError = validateSpeed(downloadSpeed);
    const uploadError = validateSpeed(uploadSpeed);

    if (downloadError || uploadError) {
      setErrors({ download: downloadError, upload: uploadError });
      return;
    }

    const download = downloadSpeed ? parseFloat(downloadSpeed) : null;
    const upload = uploadSpeed ? parseFloat(uploadSpeed) : null;

    onSave(download, upload);
    setDownloadSpeed('');
    setUploadSpeed('');
    setErrors({ download: null, upload: null });
  };

  const handleCancel = () => {
    setDownloadSpeed('');
    setUploadSpeed('');
    setErrors({ download: null, upload: null });
    onCancel();
  };

  const handleSpeedTest = e => {
    e.preventDefault();
    window.open('https://www.speedtest.net/', '_blank', 'noopener,noreferrer');
  };

  const classes = classNames(rootClassName || css.root, className);

  return (
    <Modal
      id="WifiSpeedModal"
      isOpen={isOpen}
      onClose={handleCancel}
      usePortal
      // containerClassName={css.modalContainer}
      // contentClassName={css.modalContent}
      onManageDisableScrolling={()=>{}}
      className={css.otherHomeTypeModal}

    >
      <div className={classes}>
           <div className={css.modalHeader}>
          <h2 className={css.title}>Wifi speed</h2>
          <button
            type="button"
            className={css.modalClose}
            onClick={handleCancel}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M1 1L14.3333 14.3333M1 14.3333L14.3333 1" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        
        <div className={css.speedTestLink}>
          <a
            href="https://www.speedtest.net/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleSpeedTest}
            className={css.link}
          >
            Click To Run Speed Test
          </a>
        </div>

        <div className={css.inputRow}>
          <div className={css.inputField}>
            <label htmlFor="downloadSpeed" className={css.label}>
              Download
            </label>
            <input
              id="downloadSpeed"
              type="text"
              className={classNames(css.input, {
                [css.inputError]: errors.download,
              })}
              value={downloadSpeed}
              onChange={handleDownloadChange}
              placeholder=""
            />
            {errors.download && (
              <span className={css.errorText}>{errors.download}</span>
            )}
          </div>

          <div className={css.inputField}>
            <label htmlFor="uploadSpeed" className={css.label}>
              Upload
            </label>
            <input
              id="uploadSpeed"
              type="text"
              className={classNames(css.input, {
                [css.inputError]: errors.upload,
              })}
              value={uploadSpeed}
              onChange={handleUploadChange}
              placeholder=""
            />
            {errors.upload && (
              <span className={css.errorText}>{errors.upload}</span>
            )}
          </div>
        </div>

        <div className={css.buttonGroup}>
          <PrimaryButton onClick={handleSave} className={css.saveButton}>
            Add Wifi Speed
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};

WifiSpeedModal.defaultProps = {
  isOpen: false,
  currentSpeeds: null,
  className: null,
  rootClassName: null,
};

WifiSpeedModal.propTypes = {
  isOpen: bool,
  onClose: func.isRequired,
  onSave: func.isRequired,
  onCancel: func.isRequired,
  currentSpeeds: shape({
    download: number,
    upload: number,
  }),
  className: string,
  rootClassName: string,
};

export default WifiSpeedModal;
